import Dropdown from 'react-bootstrap/Dropdown';
import MediaInfo from '@app/components/MediaInfo';
import { AutocompleteItem } from '@shared/types';
import { useCallback, useEffect, useRef, useState } from 'react';
import './AutocompleteDropdown.scss';

interface AutocompleteDropdownProps {
  autocomplete: AutocompleteItem[],
  onSelect?: (item: AutocompleteItem) => void;
}

const AutocompleteDropdown = ({ autocomplete, onSelect }: AutocompleteDropdownProps) => {
  const [maxHeight, setMaxHeight] = useState<string>('100vh');

  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);

  const handleItemClick = (item: AutocompleteItem) => {
    if (typeof onSelect === 'function') {
      onSelect(item);
    }
  };

  const handleViewportResize = useCallback(() => {
    const dropdownMenuEl = dropdownMenuRef.current;
    if (!dropdownMenuEl) {
      return;
    }

    let scrollTop = 0;
    let domEl = dropdownMenuEl as HTMLElement;
    while (domEl.parentElement){
      domEl = domEl.parentElement;
      scrollTop += domEl.scrollTop;
    }

    const viewportHeight = (window.visualViewport as VisualViewport).height;
    const { y } = dropdownMenuEl.getBoundingClientRect();

    setMaxHeight(`${viewportHeight - y - scrollTop}px`);
  }, []);

  useEffect(() => {
    if (typeof window.visualViewport?.addEventListener === 'function') {
      const viewport: VisualViewport = window.visualViewport;
      viewport.addEventListener('resize', handleViewportResize);
      handleViewportResize();

      return () => {
        viewport.removeEventListener('resize', handleViewportResize);
      };
    }
  }, []);

  return (<div className="autocomplete-dropdown">
    <Dropdown.Menu show={true} style={{maxHeight: maxHeight}} ref={dropdownMenuRef}>
      {autocomplete.map((item, index) => (
        <Dropdown.Item key={index} onClick={() => handleItemClick(item)}>
          <MediaInfo media={item} short={true}/>
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </div>);
};

export default AutocompleteDropdown;
